import { __ } from '@wordpress/i18n';
import { decodeEntities } from '@wordpress/html-entities';

/**
 * Get status
 * @param {boolean} confirmed
 * @param {boolean} joinable
 * @returns {JSX.Element}
 */
const CourseListItemCategory = ({ categories }) => {
	return (
		<div className="course-list__item__content-category">
			<span className="course-list__item__content-category-label">
				{__('Category', 'kotisivu-block-theme')}
			</span>
			{categories.map((category) => (
				<span key={category.id}>{decodeEntities(category.name)}</span>
			))}
		</div>
	);
};

export default CourseListItemCategory;
